var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "quick-responses" } },
    [
      _c("PreparedContentsToolbar", {
        attrs: {
          "search-placeholder": _vm.$t("message.search"),
          "can-create-title": _vm.checkPermission(
            _vm.PERMISSION_TYPES["prepared.create"].tr.name
          ),
          "title-button-text": _vm.$t("message.newTitleContent"),
          "content-button-text": _vm.$t("message.newDefaultContent"),
        },
        on: {
          "create-title": _vm.openNewTitleFormModal,
          "create-content": function ($event) {
            return _vm.$feature.beforeCreateReadyContent(
              _vm.openNewContentFormModal
            )
          },
        },
        model: {
          value: _vm.searchText,
          callback: function ($$v) {
            _vm.searchText = $$v
          },
          expression: "searchText",
        },
      }),
      _vm._v(" "),
      _c(
        "draggable",
        {
          staticClass: "pc-board",
          attrs: {
            options: { handle: ".pcc-drag-handle" },
            disabled: _vm.isSearchActive,
          },
          on: {
            start: _vm.handleCategoryDragStart,
            end: _vm.handleCategoryDragEnd,
          },
          model: {
            value: _vm.cloneGrouped,
            callback: function ($$v) {
              _vm.cloneGrouped = $$v
            },
            expression: "cloneGrouped",
          },
        },
        _vm._l(_vm.cloneGrouped, function (content, index) {
          return _c("PreparedContentsCategoryCard", {
            key: content._id || index,
            attrs: {
              content: content,
              "content-types": _vm.CONTENT_TYPES,
              "is-mac": _vm.isMac,
              "is-dark-mode": _vm.isDarkMode,
              move: _vm.move,
              "get-content-name": _vm.getContentName,
              "get-children": _vm.getChildren,
              "can-create-items": _vm.checkPermission(
                _vm.PERMISSION_TYPES["prepared.create"].tr.name
              ),
              "can-delete-item": _vm.checkPermission(
                _vm.PERMISSION_TYPES["prepared.delete"].tr.name
              ),
              "can-delete-category":
                !content.hasOwnProperty("children") ||
                content.children.length === 0,
              "alt-label": _vm.$t(
                _vm.isMac ? "message.newCTRLContent" : "message.newALTContent"
              ),
              "tab-label": _vm.$t("message.newTABContent"),
              "hash-label": _vm.$t("message.newHASHContent"),
              disabled: _vm.isSearchActive,
            },
            on: {
              "add-to-title": _vm.openAddContentToTitleFormModal,
              edit: _vm.edit,
              remove: _vm.remove,
              "move-end": _vm.moveEnd,
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("PreparedContentFormModal", {
        ref: "preparedContentModal",
        attrs: {
          visible: _vm.isModalShow,
          title: _vm.editMode
            ? _vm.$t("message.updateDefaultContentForm")
            : _vm.$t("message.newDefaultContentForm"),
          content: _vm.content,
          "is-child": _vm.isChild,
          "edit-mode": _vm.editMode,
          loading: _vm.loading,
          "submit-clicked": _vm.submitClicked,
          "is-mac": _vm.isMac,
          "contents-data": _vm.contents.data,
          "get-content-name": _vm.getContentName,
          "system-languages": _vm.systemLanguages,
          "default-lang": _vm.defaultLang,
          "can-update": _vm.checkPermission(
            _vm.PERMISSION_TYPES["prepared.update"].tr.name
          ),
        },
        on: {
          cancel: _vm.hideModal,
          submit: _vm.handleSave,
          "set-submit-clicked": function ($event) {
            _vm.submitClicked = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }